var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 102.375H73.5M56.0002 115.5H69.9998",
    stroke: "#E0BA56",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9055 71.8226L44.7018 77.2779C46.3279 78.8088 47.25 80.9429 47.25 83.1758C47.25 86.5305 49.9695 89.25 53.3242 89.25H72.6758C76.0305 89.25 78.75 86.5305 78.75 83.1758C78.75 80.9429 79.6719 78.8088 81.2984 77.2779L87.0943 71.8226C95.1856 64.1482 99.7038 54.0666 99.7495 43.5851L99.75 43.1449C99.75 25.2362 83.2965 10.5 63 10.5C42.7036 10.5 26.25 25.2362 26.25 43.1449L26.2504 43.5851C26.2959 54.0666 30.8143 64.1482 38.9055 71.8226Z",
    fill: "#555147",
    stroke: "#E0BA56",
    strokeWidth: 3.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.744f965283624fcdde510748f8486e3b.svg";
export { ForwardRef as ReactComponent };